import { REQUEST_LANGUAGE_SUCCEEDED } from '../constants';

export const initialState = {
  messages: {
    'translate.welcome.title': 'Hello, <br\/> {name}!',
    'translate.welcome.message': 'Have a question for us? <br\/> A member of our Customer Care team will be with you shortly.'
  }
};

export const i18nReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case REQUEST_LANGUAGE_SUCCEEDED:
      return {
        ...state,
        locale: payload.locale,
        messages: {
          ...initialState.messages,
          ...payload.messages
        }
      };
    default:
      return state;
  }
};
